import React, {Component, createRef, RefObject} from "react";
import {TFunction, withTranslation} from "react-i18next";
import {
    actionColumnDefinition,
    ColumnDefinition,
    currencyColumnDefinition,
    dateColumnDefinition,
    numericColumnDefinition,
    textColumnDefinition
} from "../table/ColumnDefinition";
import {DateObject} from "react-multi-date-picker";
import {IChargeBack} from "../../models/ISettlementData";
import {IChargeBacksRequest, IDownloadDailyESettlement} from "../../requests/ISettlementsRequest";
import Page from "../containers/page";
import ErrorsView from "../ErrorsView";
import NavigationTabLinksForSettlements from "./NavigationTabLinksForSettlements";
import FormFilter from "../containers/form-filter";
import DateField from "../controls/fields/dateField";
import SelectField from "../controls/fields/selectField";
import CustomTable, {TableModeEnum} from "../table/CustomTable";
import Button from "../controls/buttons/button";
import {ReactComponent as IconDownloadSVG} from "../../../node_modules/itd-common/assets/icons/download.svg";
import {ReactComponent as IconPrintSVG} from "../../../node_modules/itd-common/assets/icons/icon-print-white.svg";
import {
    ReactComponent as IconDownloadWhiteSVG
} from "../../../node_modules/itd-common/assets/icons/icon-download-white.svg";
import {FiscalSettlementService} from "../../services/FiscalSettlementService";
import {DateHelper} from "../../helpers/DateHelper";
import {UtilService} from "../../services/UtilService";
import {Option} from "../../models/Option";
import {WebCache} from "../../services/WebCache";
import {toast} from "react-toastify";
import {AxiosResponse} from "axios";
import CustomReCAPTCHA from "../CustomCaptcha";
import './Settlement.scss'
import TextField from "../controls/fields/textField";
import {UserService} from "../../services/UserService";
import i18next from "i18next";
import ReactToPrint from "react-to-print";
import {CurrencyHelper} from "../../helpers/CurrencyHelper";
import {ReactComponent as IconInfoSVG} from "../../../node_modules/itd-common/assets/icons/alert-information.svg";
import {IPageRequest} from "../../models/IPageRequest";
import FilterFiscalDocumentAndCommerce, {MultiSelectRef} from "../FilterFiscalDocumentAndCommerce";
import {OverlayTrigger, Tooltip as BootstrapTooltip} from "react-bootstrap";
import {IMessageContext} from "../MessagesContext";
import {withMessages} from "../contexts/MessagesContext";
import Pagination from "../Pagination";
import { SettlementService } from "../../services/SettlementService";

interface IProps {
    t: TFunction
    messages: IMessageContext
}
interface IFilters {
    dateRange: Array<DateObject>,
    voucherNumber: number,
    type: string,
    fiscalDocument: string[],
    merchantNumber: string[],
    amount:string,
    currency: string
}
interface IState {
    mainPage: number,
    pageRequest: IPageRequest,
    settlements: IChargeBack[],
    errors: string[],
    filters: IFilters,
    currencyOptions: Array<HTMLOptionElement>,
    typeOptions: Array<HTMLOptionElement>,
    allFiscalDocuments: Array<Option>,
    isCaptchaVerified:boolean,
    pages: number[],
    activePage:number,
    maxDayRange:number
}

const T_PREFIX: string = 'pages.settlementChargeBacks.';
const pageSize=20
const pageQuantity=3
const defaultPages = [1, 2, 3]
class SettlementChargeBacks extends Component<IProps, IState> {
    private columnDefinitions: Array<ColumnDefinition> = [];
    private componentRef:RefObject<any> = React.createRef();
    private multiSelectRef = createRef<MultiSelectRef>();
    private messages: IMessageContext = this.props.messages;
    private divColumnSize: string = UtilService.isMobilePlatform() ? "col-md-6" : "col-md-6 col-lg-4";

    constructor(props: IProps) {
        super(props);
        const currencyOptions: Array<HTMLOptionElement> = UtilService.getCurrencyOptions();
        const currencyFilter: string = currencyOptions[0].value;
        const typeOptions: Array<HTMLOptionElement> = this.props.t(`${T_PREFIX}tipos`, { returnObjects: true });
        const type: string = typeOptions[0].value;
        
        const currency: number = 858;
        this.columnDefinitions = [
            dateColumnDefinition({ key: 'presentationDate', label: `${T_PREFIX}columns.paymentDate`, header: true, mapValue: (settlement: IChargeBack) => {
                const dateParts = settlement.presentationDate.split("-");
                const day = dateParts[2];
                const month = dateParts[1];
                const year = dateParts[0];

                return `${day}/${month}/${year}`;
            } }),
            textColumnDefinition({ key: 'currencyCode', label: `${T_PREFIX}columns.currencyDesc`, header: true}),
            currencyColumnDefinition({ key: 'grossAmount', label: `${T_PREFIX}columns.grossAmount`, header: true, columnDefinitionKey:'currencyCode' }),
            currencyColumnDefinition({ key: 'netAmount', label: `${T_PREFIX}columns.netAmount`, header: true, columnDefinitionKey:'currencyCode' }),
            textColumnDefinition({ key: 'voucherNumber', label: `${T_PREFIX}columns.voucherNumber`, header: true }),
            textColumnDefinition({ key: 'last4NumCard', label: `${T_PREFIX}columns.last4NumCard`, header: true }),
            textColumnDefinition({ key: 'detail', label: `${T_PREFIX}columns.detail`, header: true }),
            numericColumnDefinition({ key: 'settlmentNumber', label: `${T_PREFIX}columns.settlmentNumber`, header: true }),
            actionColumnDefinition({ key: 'edit', label: `${T_PREFIX}columns.download`, header: true, action: { function: (rowObject: IChargeBack) => {
                this.getDowloadESettlement(rowObject.fiscalNumber,rowObject.settlmentNumber,rowObject.settlmentNumber,
                    rowObject.merchantNumber,rowObject.productCode,rowObject.productDesc,rowObject.presentationDate);
            }, icon: <IconDownloadSVG className="icon-download"></IconDownloadSVG>} })
        ];

        this.state = {
            mainPage: 0,
            pageRequest: {
                Skip: 0,
                Take: 0
            },
            activePage:1,
            pages:defaultPages,
            settlements: [] as IChargeBack[],
            errors: [],
            filters: {
                amount:'',
                dateRange: [],
                voucherNumber: 0,
                type,
                fiscalDocument: [""],
                merchantNumber:[""] ,
                currency: currencyFilter
            },
            allFiscalDocuments: WebCache.getAllMerchantDocuments(false,true),
            currencyOptions,
            typeOptions,
            isCaptchaVerified: sessionStorage.getItem('captchaVerified')=="true",
            maxDayRange:30
        };
    }

    getDowloadESettlement = (fiscalNumber:string,fileName: string, settlmentNumber: string,
        merchantNumber: string,productCode:string,productDesc:string,paymentDate:string) => {
        if (this.state.isCaptchaVerified) {
            this.messages.showDownloadMessage();
            FiscalSettlementService.getDowloadDailyESettlement(this.getDownloadDailyESettlementRequest(fiscalNumber,fileName,
                settlmentNumber, merchantNumber,productCode,productDesc,paymentDate))
                .then((response: AxiosResponse<Blob>) => {
                })
                .catch((error) => {
                    this.setState({  errors: ["Error obteniendo datos del servidor"] });
                    console.log('error:', error);
                });
        } else {
            toast.error("Por favor, verifica el CAPTCHA antes de descargar el archivo");
        }
    };

    getDownloadDailyESettlementRequest = (fiscalNumber: string,fileName: string, settlmentNumber: string,
        merchantNumber: string,productCode:string,productDesc:string,paymentDate:string): IDownloadDailyESettlement => {
        const [year,month, day] = paymentDate.split('-');
        const formattedDate = `${year}${month.padStart(2, '0')}${day.padStart(2, '0')}`;

        const result: IDownloadDailyESettlement = {
            FileName: fileName,
            SettlementNumber: parseInt(settlmentNumber),
            FiscalNumber: fiscalNumber,
            MerchantNumber:merchantNumber,
            ProductCode:productCode,
            ProductDesc:productDesc,
            PaymentDate:formattedDate
        };
        return result;
    }

    getRequest = (all: boolean): IChargeBacksRequest => {
        const request: IChargeBacksRequest = {
            CouponNumber: this.state.filters.voucherNumber>0?this.state.filters.voucherNumber+"":"",
            From: DateHelper.dateObjectToString(this.state.filters.dateRange[0]),
            To: DateHelper.dateObjectToString(this.state.filters.dateRange[1]),
            Type: this.state.filters.type,
            Amount:this.state.filters.amount,
            Currency: this.state.filters.currency,
            MerchantDocuments: this.state.filters.fiscalDocument.includes("all") ? [] : this.state.filters.fiscalDocument.filter(x=>x.length>0),
            MerchantNumbers: this.state.filters.merchantNumber.includes("all")? [] : this.state.filters.merchantNumber.filter(x=>x.length>0),
            Skip: all ? 0 : (this.state.mainPage * pageSize * pageQuantity),
            Take: all ? 0 : ((pageSize * pageQuantity) + 1),
            AddDetail:false
        };
        return request;
    }

    handleCaptchaVerification = (verified: boolean) => {
        this.setState({ isCaptchaVerified: verified });
    };

    // downloadGrid = () => {
    //     let fileName="Ajustes.csv";
    //     this.messages.showDownloadMessage();
    //     UserService.getCsvOnline(this.columnDefinitions.filter(x=>x.action==null).map(x=>i18next.t(x.label+"")).join(";")+"\r\n"+
    //         // @ts-ignore
    //         this.state.settlements.map(y=>this.columnDefinitions.map(x=>y[x.key]).join(";")).join("\r\n"), fileName).then((response: AxiosResponse<any>) => {
    //         //const outputFilename = `TerminalsReport${Date.now()}.xlsx`;
    //         // @ts-ignore
    //         /*let outputFilename = response.headers['content-disposition']
    //             .split(';')
    //             .find((n: any) => n.includes('filename='))
    //             .replace('filename=', '')
    //             .trim();*/
    //         const url = URL.createObjectURL(new Blob([response.data]));
    //         const link = document.createElement('a');
    //         link.href = url;
    //         link.setAttribute('download', fileName);
    //         link.click();
    //     }).catch(error => {
    //         console.log('error:', error);
    //     });
    // }

    downloadGrid = () => {
            this.messages.showDownloadMessage();
            SettlementService.generateChargeBacksSettlementExcel(this.getRequest(true)).then((response: AxiosResponse<Blob>) => {
            }).catch(error => {
                this.setState({...this.state,errors: error.response.data});
                console.log('error: ', error);
            });
        }

    getChargeBacks = () => {

        let dateFrom= DateHelper.dateObjectToDate(this.state.filters.dateRange[0]);
        let dateTo= DateHelper.dateObjectToDate(this.state.filters.dateRange[1]);
        let diffDays = Math.round((dateTo.getTime() - dateFrom.getTime()) / (1000 * 3600 * 24));
                
        if(diffDays>this.state.maxDayRange){
            toast.error(`La busqueda no puede superar los ${this.state.maxDayRange} días`);
            return;
        }

        FiscalSettlementService.getChargeBacks(this.getRequest(false))
        .then((response1) => {
            return response1.data;
        })
        .then((response: IChargeBack[]) => {
            this.setState({...this.state,
                settlements: response,
                errors: []
            });
        }).catch(error => {
            this.setState({...this.state,
                errors: ["Error obteniendo datos del servidor"],
                settlements: [] as IChargeBack[]
            })
        });
    }

    searchFilter = () => {
        this.setState({
            ...this.state, 
            activePage: 1, 
            pages: defaultPages,
            mainPage: 0
        }, () => {
            this.getChargeBacks();
        });
    }

    setFilters(filters: IFilters) {
        this.setState({ ...this.state, filters });
    }

    clearFilter = () => {
        const currencyOptions: Array<HTMLOptionElement> = UtilService.getCurrencyOptions();
        const currencyFilter: string = currencyOptions[0].value;
        const typeOptions: Array<HTMLOptionElement> = this.props.t(`${T_PREFIX}tipos`, { returnObjects: true });
        const type: string = typeOptions[0].value;
        this.multiSelectRef.current?.clearFilters();
        this.setState((prevState) => ({
            ...prevState,
            filters: {
                ...prevState.filters,
                amount:'',
                dateRange: [],
                voucherNumber: 0,
                type,
                fiscalDocument: [""],
                merchantNumber:[""] ,
                currency: currencyFilter
            },
        }), ()=>{
            this.searchFilter();
        });
    }
    renderTextInfo = () : JSX.Element => {
        const { t } = this.props;
        return <div className={`text-info`}>
                    <p className='p-3 text-white'>{t(`${T_PREFIX}text-info-total`)}</p>
                </div>
    }

    renderTotalNetAmounts = (chargeBacks: IChargeBack[], isCurrencyUSD: boolean) => {
        const { t } = this.props;
        let totalNetAmount= "";
        if(!isCurrencyUSD){ // Neto total para la moneda Pesos uruguayos
            totalNetAmount = Intl.NumberFormat('es-UY', { style: 'currency', currency: CurrencyHelper.getCurrencySymbol("858") }).format(
                chargeBacks.reduce((acc, dailySettlement) => {
                    return dailySettlement.currencyCode != '840' ? acc + dailySettlement.netAmount : acc;
                }, 0)
            );
        }else { // Neto total para la moneda de USD
            totalNetAmount = Intl.NumberFormat('es-UY', { style: 'currency', currency: CurrencyHelper.getCurrencySymbol("840") }).format(
                chargeBacks.reduce((acc, dailySettlement) => {
                    return dailySettlement.currencyCode === '840' ? acc + dailySettlement.netAmount : acc;
                }, 0)
            );
        }
        return <>
            <div className='d-flex d-inline'>
                <label className="form-label mt-0 w-70 fs-5"> {t('netTotal')}</label>
                <span className='w-50'>
                    <OverlayTrigger
                        placement={'top'}
                        delay={{ show: 250, hide: 400 }}
                        overlay={
                            <BootstrapTooltip>
                                {this.renderTextInfo()}
                            </BootstrapTooltip>
                        }
                    >
                        <a className='float-right button-text-info-1' {...UtilService.isMobilePlatform()?{}:{type:'button'}}>
                            <IconInfoSVG className='fs-3 pe-2'></IconInfoSVG>
                        </a>
                    </OverlayTrigger>
                </span>
            </div>
            <label  className="border-start-0 ms-0 mt-2 amount-label" >
                {totalNetAmount}
            </label>
        </>
    }

    render() {
        const { t } = this.props;
        let taxPayerId
        if (WebCache.isUserUYU()) {
            taxPayerId=`${T_PREFIX}merchantURU`
        } else {
            taxPayerId=`${T_PREFIX}merchantARG`
        }		

        return (
            <Page>
                <>
                    <h2>{t(`settlements`)}</h2>
                    <div className='row'>
                        <div className='col-lg-12'>
                            <ErrorsView errors={this.state.errors}/>
                        </div>
                    </div>
                    <div className="row" ref={this.componentRef}>
                        <div className="col-lg-12 settlement">
                            <div className="col-lg-12 mt-2">
                                <NavigationTabLinksForSettlements></NavigationTabLinksForSettlements>
                            </div>
                            <FormFilter
                                onSubmit={this.searchFilter}
                                clear={this.clearFilter}
                                hidden={UtilService.isMobilePlatform()? true : false}
                                model={[this.state.filters, this.setFilters.bind(this)]}>
                                <>
                                    <div className="row mt-2">
                                        <div className={this.divColumnSize}>
                                            <DateField attr="dateRange" label="dateRange" range></DateField>
                                        </div>
                                        <div className={this.divColumnSize}>
                                            <TextField attr="voucherNumber"
                                                    label={`${T_PREFIX}voucherNumber`}></TextField>
                                        </div>
                                        <FilterFiscalDocumentAndCommerce
                                            changeFilter={(fiscalDocument, merchantNumber)=>{ this.setState({
                                                ...this.state,
                                                filters: {
                                                    ...this.state.filters,
                                                    merchantNumber: merchantNumber,
                                                    fiscalDocument: fiscalDocument
                                                }
                                            }); }}
                                            ref={this.multiSelectRef}
                                            includeAllFiscalDocument={true}
                                            includeWholesaler={true}
                                        />
                                        <div className={this.divColumnSize}>
                                            <SelectField attr='type' label='type'
                                                        options={this.state.typeOptions}></SelectField>
                                        </div>
                                        <div className={this.divColumnSize}>
                                            <SelectField attr='currency' label='currency' options={this.state.currencyOptions} ></SelectField>
                                        </div>
                                    </div>
                                </>
                            </FormFilter>
                            {/*<section className="row pb-4 ms-1">
                                <div className="col-md-3 div-info me-4" style={{textAlign:"start"}}>
                                    {this.renderTotalNetAmounts(this.state.settlements, false)}
                                </div>
                                <div className="col-md-3 div-info" style={{textAlign:"start"}}>
                                    {this.renderTotalNetAmounts(this.state.settlements, true)}
                                </div>
                            </section>*/}
                            <nav className="nav mt-3">
                            <div className="navbar-text ms-auto mb-3 col-12 col-md-6 fs-5 pe-0 d-flex flex-wrap justify-content-end">
                                {UtilService.isMobilePlatform()?"":
                                <div className="me-3 mb-2 flex-grow-1">
                                    <ReactToPrint
                                        trigger={() => (
                                            <Button color="primary" className="border-0 mt-0 w-100" noBlock>
                                                <>
                                                    <span className="ms-2 me-2 text-white">{t(`common.action.print`)}</span>
                                                    <IconPrintSVG></IconPrintSVG>
                                                </>
                                            </Button>
                                        )}
                                        content={() => this.componentRef.current}
                                    />
                                </div>}
                                <div className="me-3 mb-2 flex-grow-1">
                                    <Button color="primary" className="border-0 mt-0 w-100" onClick={() => this.downloadGrid()} noBlock>
                                        <>
                                            <span className="ms-2 me-2">{t(`common.action.downloadCsv`)}</span>
                                            <IconDownloadWhiteSVG></IconDownloadWhiteSVG>
                                        </>
                                    </Button>
                                </div>                                                                
                            </div>
                        </nav>
                            <div className='row'>
                                <div className="col-md-12">
                                    {UtilService.isMobilePlatform() ? 
                                    <div>
                                        <div className="container">
                                            <ul className="notification">
                                                {
                                                    this.state.settlements.slice(this.state.pages.indexOf(this.state.activePage) * pageSize, (this.state.pages.indexOf(this.state.activePage) * pageSize) + pageSize).map((settlements, Tindex) => {
                                                        return (
                                                            <li>
                                                                <div className="notification-time-date mb-2 d-block d-md-none">
                                                                    <span className="date">{settlements.presentationDate}</span>
                                                                </div>
                                                                <div className="settlementMobile">
                                                                    <div className="media mt-0">
                                                                        <div style={{ width: "34px",height: "30px"}}>
                                                                            <a onClick={() => { this.getDowloadESettlement(settlements.fiscalNumber,settlements.settlmentNumber,settlements.settlmentNumber,settlements.merchantNumber,settlements.productCode,settlements.productDesc,settlements.presentationDate);}}>
                                                                                <a className="download-link"><IconDownloadSVG></IconDownloadSVG></a>
                                                                            </a>
                                                                        </div>
                                                                        <div className="media-body ms-3 d-flex">
                                                                            <div className="" >
                                                                                <span className='amount-label'>{Intl.NumberFormat('es-UY', { style: 'currency', currency: settlements.currencyCode=="840"?"USD":"UYU" }).format(
                                                                                    settlements.netAmount)}
                                                                                </span>
                                                                                <p className="mb-0 fs-13 text-dark">{t("settlementNumber")}:{(settlements.settlmentNumber)}</p>
                                                                                <p className="mb-0 fs-13 text-dark">{t("merchantNumber")}:{(settlements.merchantNumber)}</p>
                                                                                <p className="mb-0 fs-13 text-dark">{t(`${T_PREFIX}columns.voucherNumber`)}:{(settlements.voucherNumber)}</p>
                                                                                <p className="mb-0 fs-13 text-dark">{t(`${T_PREFIX}columns.detail`)}:{(settlements.detail)}</p>
                                                                            </div>
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </li>
                                                        )
                                                    })}
                                                </ul>
                                            </div>
                                            <div>
                                                <Pagination
                                                    pageSize={pageSize}
                                                    pageQuantity={pageQuantity}
                                                    modifyMainPage={(value: number, newPages: Array<number>) => {
                                                        this.setState({
                                                            mainPage: this.state.mainPage + value,
                                                            pages: newPages
                                                        }, () => this.getChargeBacks());
                                                    }}
                                                    changePage={(page: number) => this.setState({ activePage: page })}
                                                    dataL={this.state.settlements.length}
                                                    mainPage={this.state.mainPage}
                                                ></Pagination>
                                            </div>
                                        </div>:
                                    <CustomTable
                                        rowObjects={this.state.settlements}
                                        columnDefinitions={this.columnDefinitions}
                                        config={{
                                            pageSize:pageSize,
                                            mode: TableModeEnum.LIST,
                                            paginator: {
                                                quantity:3,
                                                mainPage: this.state.mainPage,
                                                modifyMainPage: (value: number) => {
                                                    this.setState({
                                                        mainPage: this.state.mainPage + value
                                                    }, () => this.getChargeBacks())
                                                },
                                                pageRequest: this.state.pageRequest
                                            }
                                        }}
                                    ></CustomTable>} 
                                </div>
                            </div>
                            <div className='row'>
                                <div className='col-md-6'>
                                </div>
                                <div className="col-md-6 d-flex justify-content-center align-items-start">
                                    <CustomReCAPTCHA useCache={true} onVerify={this.handleCaptchaVerification}></CustomReCAPTCHA>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            </Page>
        );
    }
}

export default withMessages(withTranslation() (SettlementChargeBacks));